module.exports = __webpack_public_path__ + "static/media/sasha-grey-lesb.c9018d89.jpg";